import React, { useEffect, useState } from "react";
import PageTitle from "../../layout/PageTitle";
import { getAllBlogs } from "../../apis/BlogApi";
import { Link } from "react-router-dom";
import Loader from "../../common/Loader";

function Blog({ setTab }) {
  const [blogs, setBlogs] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showCommentsDialog, setShowCommentsDialog] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const stripHtmlTags = (html) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  useEffect(() => {
    setTab("blogs");
    fetchBlogs(currentPage);
  }, [setTab, currentPage]);

  const fetchBlogs = async (page) => {
    try {
      setLoading(true);
      const response = await getAllBlogs(page - 1, 9);
      setBlogs(response.data || []);
      setTotalPages(response.meta.totalPages);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleComments = (blog) => {
    setSelectedBlog(blog);
    setShowCommentsDialog(true);
  };

  const closeCommentsDialog = () => {
    setShowCommentsDialog(false);
    setSelectedBlog(null);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    pages.push(
      <button
        key="prev"
        className={`page-numbers ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="ti ti-arrow-left"></i>
      </button>
    );

    // First page
    if (startPage > 1) {
      pages.push(
        <button
          key="1"
          className="page-numbers"
          onClick={() => handlePageChange(1)}
        >
          1
        </button>
      );
      if (startPage > 2) {
        pages.push(
          <span key="dots1" className="page-numbers dots">
            ...
          </span>
        );
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`page-numbers ${currentPage === i ? "current" : ""}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <span key="dots2" className="page-numbers dots">
            ...
          </span>
        );
      }
      pages.push(
        <button
          key={totalPages}
          className="page-numbers"
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    // Next button
    pages.push(
      <button
        key="next"
        className={`page-numbers ${
          currentPage === totalPages ? "disabled" : ""
        }`}
        onClick={() =>
          currentPage < totalPages && handlePageChange(currentPage + 1)
        }
        disabled={currentPage === totalPages}
      >
        <i className="ti ti-arrow-right"></i>
      </button>
    );

    return pages;
  };

  if (loading) {
    return (
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            zIndex: 9999,
          }}
        >
          <Loader />
        </div>
      </>
    );
  }

  return (
    <>
      <PageTitle page="Blogs" setTab={setTab} />
      <div className="site-main">
        <section className="ttm-row grid-section clearfix">
          <div className="container">
            <div className="row">
              {blogs.map((blog) => (
                <div key={blog.id} className="col-lg-4 col-md-6 col-sm-6">
                  <div className="featured-imagebox featured-imagebox-post style3">
                    <div className="ttm-post-thumbnail featured-thumbnail">
                      <Link to={`/blogs/${blog.id}`} rel="bookmark">
                        <img
                          className="img-fluid"
                          style={{
                            height: "250px",
                            width: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          src={
                            blog?.files.length
                              ? blog.files[0].url
                              : "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/BannerLogo.png"
                          }
                          alt={blog.name || "altImage"}
                        />
                      </Link>
                    </div>
                    <div className="featured-content">
                      <div className="post-meta ttm-bgcolor-skincolor">
                        <Link to={`/blogs/${blog.id}`} rel="bookmark">
                          <span className="ttm-meta-line post-date">
                            <i className="fa fa-calendar"></i>

                            <time
                              className="entry-date published"
                              dateTime={blog.createdAt}
                            >
                              {new Date(blog.createdAt).toLocaleDateString(
                                "en-US",
                                {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                }
                              )}
                            </time>
                          </span>
                          <span className="ttm-meta-line byline">
                            <i className="fa fa-user"></i>
                            {"Admin"}
                          </span>
                        </Link>
                      </div>
                      <div className="featured-title">
                        <h3>
                          <Link to={`/blogs/${blog.id}`}>{blog.title}</Link>
                        </h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          {stripHtmlTags(blog.description)?.substring(0, 100)}
                          {stripHtmlTags(blog.description)?.length > 100
                            ? "..."
                            : ""}
                        </p>
                      </div>
                      <div className="post-footer">
                        <div className="post-footer-link">
                          <Link
                            className="ttm-btn btn-inline d-block ttm-btn-size-md ttm-btn-color-skincolor"
                            to={`/blogs/${blog.id}`}
                          >
                            Read More
                          </Link>
                        </div>
                        <div className="post-footer-comment">
                          <span
                            onClick={() => handleComments(blog)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fa fa-comments ttm-textcolor-skincolor mr-2"></i>
                            {blog.comments?.length || 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {totalPages > 1 && (
          <div className="pagination-block text-center mt-4">
            {renderPagination()}
          </div>
        )}
      </div>

      {/* Comments Dialog */}
      {showCommentsDialog && selectedBlog && (
        <div className="comments-dialog-overlay" onClick={closeCommentsDialog}>
          <div className="comments-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="comments-dialog-header">
              <h3>Comments ({selectedBlog.comments?.length || 0})</h3>
              <button className="close-button" onClick={closeCommentsDialog}>
                <i className="fa fa-times-circle"></i>
              </button>
            </div>
            <div className="comments-dialog-content">
              {selectedBlog.comments && selectedBlog.comments.length > 0 ? (
                selectedBlog.comments.map((comment, index) => (
                  <div key={index} className="comment-item">
                    <div className="comment-header">
                      <span className="comment-author">
                        <i className="fa fa-user"></i> {comment.name}
                      </span>
                      <span className="comment-date">
                        <i className="fa fa-calendar"></i>{" "}
                        {new Date(comment.createdAt).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        )}
                      </span>
                    </div>
                    <div className="comment-content">{comment.comment}</div>
                  </div>
                ))
              ) : (
                <p className="no-comments">
                  No comments yet. Be the first to comment!
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .comments-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 15px;
        }

        .comments-dialog {
          background: white;
          border-radius: 8px;
          width: 100%;
          max-width: 600px;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
          position: relative;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .comments-dialog-header {
          padding: 12px 15px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #f8f8f8;
          border-radius: 8px 8px 0 0;
        }

        .comments-dialog-header h3 {
          margin: 0;
          color: #333;
          font-size: 16px;
          font-weight: 600;
        }

        .close-button {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: #666;
          padding: 4px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.3s ease;
        }

        .close-button:hover {
          color: #333;
        }

        .close-button i {
          font-size: 24px;
        }

        .comments-dialog-content {
          padding: 15px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }

        .comment-item {
          padding: 12px 0;
          border-bottom: 1px solid #eee;
        }

        .comment-item:last-child {
          border-bottom: none;
        }

        .comment-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          color: #666;
          font-size: 0.85em;
          flex-wrap: wrap;
          gap: 8px;
        }

        .comment-author {
          font-weight: 500;
          color: #333;
        }

        .comment-author i,
        .comment-date i {
          font-size: 12px;
          margin-right: 4px;
        }

        .comment-content {
          color: #444;
          line-height: 1.4;
          font-size: 0.95em;
          word-break: break-word;
        }

        .no-comments {
          text-align: center;
          color: #666;
          padding: 15px;
          font-size: 0.9em;
        }

        .modal-close-icon {
          position: absolute;
          top: 15px;
          right: 15px;
          font-size: 24px;
          color: #666;
          cursor: pointer;
          transition: color 0.3s ease;
          z-index: 1;
        }

        .modal-close-icon:hover {
          color: #333;
        }

        /* Responsive Styles */
        @media screen and (max-width: 768px) {
          .comments-dialog {
            max-height: 95vh;
            margin: 0;
            border-radius: 0;
          }

          .comments-dialog-header {
            padding: 10px;
            border-radius: 0;
          }

          .comments-dialog-header h3 {
            font-size: 15px;
          }

          .comments-dialog-content {
            padding: 12px;
          }

          .comment-header {
            flex-direction: column;
            gap: 4px;
          }

          .comment-date {
            font-size: 0.8em;
          }

          .modal-close-icon {
            top: 10px;
            right: 10px;
            font-size: 20px;
          }
        }

        @media screen and (max-width: 480px) {
          .comments-dialog-overlay {
            padding: 10px;
          }

          .comments-dialog-header h3 {
            font-size: 14px;
          }

          .close-button i {
            font-size: 20px;
          }

          .comment-content {
            font-size: 0.9em;
          }

          .modal-close-icon {
            font-size: 18px;
          }
        }

        /* For very small screens */
        @media screen and (max-height: 500px) {
          .comments-dialog {
            max-height: 100vh;
          }

          .comments-dialog-header {
            padding: 8px 10px;
          }

          .comments-dialog-content {
            padding: 10px;
          }

          .comment-item {
            padding: 8px 0;
          }
        }

        .featured-thumbnail {
          height: 250px;
          overflow: hidden;
          position: relative;
        }

        .featured-thumbnail img {
          transition: transform 0.3s ease;
        }

        .featured-thumbnail:hover img {
          transform: scale(1.05);
        }
      `}</style>
    </>
  );
}

export default Blog;
